// tslint:disable
export var Dpv;
(function (Dpv) {
    // DPV unknown or not provided
    Dpv[Dpv["Unknown"] = 0] = "Unknown";
    // Address is a valid mailing address
    Dpv[Dpv["Valid"] = 1] = "Valid";
    // Address is not in the DPV database of valid mailing addresses
    Dpv[Dpv["Invalid"] = 2] = "Invalid";
    // Apartment or Rural Route Box invalid
    Dpv[Dpv["AptOrRrBoxInvalid"] = 3] = "AptOrRrBoxInvalid";
    // Apartment or Rural Route Box missing
    Dpv[Dpv["AptOrRrBoxMissing"] = 4] = "AptOrRrBoxMissing";
})(Dpv || (Dpv = {}));
Dpv['UNKNOWN'] = 0;
Dpv['VALID'] = 1;
Dpv['INVALID'] = 2;
Dpv['APTORRRBOXINVALID'] = 3;
Dpv['APTORRRBOXMISSING'] = 4;
//# sourceMappingURL=Dpv.js.map